// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e6aac567a268bc78","3550":"085c5bf262e7f4ca","4472":"fffabcb86dc50ebd"}[chunkId] + ".css";
};